import { useContext } from "react";
import { useNavigate } from "react-router";
import {
  Content,
  Text,
  Heading,
  ActionButton,
  Badge,
  InlineAlert,
} from "@react-spectrum/s2";

import { VideoWizardContext } from "@app/views/projects/videoWizardContext";
import { DevToolbarItem } from "@app/views/projects/DevToolbar";
import { WIZARD_STEP } from "../wizardSteps";
import { Step } from "./Step";
import { TemplatesList } from "./TemplatesList";
import { AccountDetailsStep } from "./AccountDetailsStep";

import { style, size } from "@react-spectrum/s2/style" with { type: "macro" };

export const TemplateStep = () => {
  const navigate = useNavigate();

  const {
    currentStep,
    templates,
    template,
    selectedTemplateKey,
    handleTemplateSelectionChange,
    handleTemplateContinue,
    handleNextStep,
    sfType,
    setSfType,
    drNumbers,
    drNumbersFilter,
    setDrNumbersFilter,
    drNumber,
    handleDrNumbersSelectionChange,
    accountName,
    setAccountName,
  } = useContext(VideoWizardContext);

  return (
    <>
      <Step styles={style({ gridArea: "content" })}>
        <Step.Header
          title="Select a template"
          subtitle="Select the template that best fits your message."
        >
          <Text
            styles={style({
              display: "inline-flex",
              alignItems: "center",
              font: "body",
              marginTop: 16,
            })}
          >
            <Text>or try out the new </Text>
            <ActionButton
              onPress={() => navigate("/projects/composer")}
              size="M"
              staticColor="auto"
              styles={style({
                marginStart: 8,
                marginEnd: 4,
              })}
            >
              <Text styles={style({ marginEnd: size(-7) })}>
                <Text>Video Composer</Text>
                <Badge
                  size="XS"
                  variant="yellow"
                  styles={style({
                    marginStart: 8,
                  })}
                  UNSAFE_className={style({
                    verticalAlign: "baseline",
                    borderRadius: "sm",
                  })}
                  UNSAFE_style={{
                    paddingInlineStart: size(6),
                    paddingInlineEnd: size(6),
                    display: "inline-flex",
                  }}
                >
                  Alpha
                </Badge>
              </Text>
            </ActionButton>
            {/* <Link href="/projects/new" isQuiet>
              Partnership Video
              <Badge
                size="XS"
                variant="yellow"
                styles={style({
                  marginStart: 8,
                })}
                UNSAFE_className={style({ verticalAlign: "text-top" })}
                UNSAFE_style={{
                  display: "inline-flex",
                }}
              >
                Alpha
              </Badge>
            </Link> */}
          </Text>
        </Step.Header>

        <TemplatesList
          templates={templates}
          selectedTemplateKey={selectedTemplateKey}
          onSelectionChange={handleTemplateSelectionChange}
          isDisabled={currentStep !== WIZARD_STEP.SELECT_TEMPLATE}
        />
      </Step>

      <AccountDetailsStep
        isOpen={currentStep === WIZARD_STEP.ACCOUNT_DETAILS}
        sfType={sfType}
        onSfTypeChange={setSfType}
        accountName={accountName}
        onAccountNameChange={setAccountName}
        drNumbers={drNumbers}
        drNumbersFilter={drNumbersFilter}
        onDrNumbersFilterChange={setDrNumbersFilter}
        drNumber={drNumber}
        onDrNumbersSelectionChange={handleDrNumbersSelectionChange}
        onCancel={() => handleNextStep(WIZARD_STEP.SELECT_TEMPLATE)}
        onContinue={() => handleNextStep(WIZARD_STEP.CUSTOMER_DETAILS)}
      />

      {currentStep === WIZARD_STEP.SELECT_TEMPLATE && (
        <>
          {!!template.data?.disclaimer && (
            <div
              className={style({
                gridArea: "info",
                justifySelf: "end",
                position: "sticky",
                bottom: 80,
              })}
            >
              <InlineAlert
                variant="neutral"
                styles={style({ width: 640, marginY: 24 })}
              >
                <Heading>{template.data.disclaimer.heading}</Heading>
                <Content>{template.data.disclaimer.content}</Content>
              </InlineAlert>
            </div>
          )}
        </>
      )}

      <DevToolbarItem
        isPending={templates.isFetching}
        onPress={() => templates.refetch()}
      >
        Refetch template
      </DevToolbarItem>
    </>
  );
};
